import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import { array } from 'prop-types';
import ReplyListItem from './ReplyListItem';
import { compareTs } from '../../utils/utils';

const propTypes = {
  replies: array.isRequired,
};

const defaultProps = {
  replies: [],
};

const getDateLabel = (timestamp) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const date = new Date(timestamp * 1000);
  date.setHours(0, 0, 0, 0);

  if (date.getTime() === today.getTime()) {
    return 'Сегодня';
  }

  if (date.getTime() === yesterday.getTime()) {
    return 'Вчера';
  }

  return null;
};

const renderDate = (date = 0, index = 0, values = []) => {
  const shouldRender = (() => {
    if (index === 0) return true;
    if (values[index - 1]) {
      const { reply } = values[index - 1];
      return !compareTs(date, reply.its, 'day');
    }
    return false;
  })();

  if (!shouldRender) return null;

  const dateLabel = getDateLabel(date);

  return (
    <div className="replies-list-date">
      {dateLabel ? (
        <h6 className="replies-list-date-value">{dateLabel}</h6>
      ) : (
        <Moment element="h6" className="replies-list-date-value" format="DD MMMM" unix>
          {date}
        </Moment>
      )}
    </div>
  );
};

const ReplyList = ({ replies, login, avatar, ticketId, getTicket }) => {
  const sortedReplies = [...replies].sort((a, b) => a.reply.its - b.reply.its);

  return (
    <div className="replies-list">
      {sortedReplies.length > 0 &&
        sortedReplies.map(({ files, reply }, index, values) => (
          <Fragment key={reply.id}>
            {renderDate(reply.its, index, values)}
            <ReplyListItem
              login={login}
              avatar={avatar}
              reply={reply}
              files={files}
              ticketId={ticketId}
              getTicket={getTicket}
            />
          </Fragment>
        ))}
    </div>
  );
};

ReplyList.propTypes = propTypes;
ReplyList.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  login: state.webmaster.profile.login,
  avatar: state.webmaster.profile.img,
});

export default connect(mapStateToProps)(ReplyList);
